import http from "./http";

export const AddVariant = async data => {
    return await http.post("/variants", data);
};

export const DeleteVariant = async id => {
    return await http.delete(`/variants/${id}`);
};
